import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { patch } from '@ngxs/store/operators';
import { CloseDialog, OpenDialog, SetCloseResult } from './confirmation-dialog.actions';

export type ConfirmationDialogStateModel = {
  title: string;
  content: string;
  open: boolean;
  closeResult: boolean | null;
};

export const initialState: ConfirmationDialogStateModel = {
  title: '',
  content: '',
  open: false,
  closeResult: null,
};

@State<ConfirmationDialogStateModel>({
  name: 'confirmationDialog',
  defaults: initialState,
})
@Injectable()
export class ConfirmationDialogState {
  @Selector()
  static open(state: ConfirmationDialogStateModel): boolean {
    return state.open;
  }

  @Selector()
  static title(state: ConfirmationDialogStateModel): string {
    return state.title;
  }

  @Selector()
  static content(state: ConfirmationDialogStateModel): string {
    return state.content;
  }

  @Selector()
  static closeResult(state: ConfirmationDialogStateModel) {
    return state.closeResult;
  }

  @Action(OpenDialog)
  openDialog(context: StateContext<ConfirmationDialogStateModel>, { title, content }: OpenDialog) {
    context.setState(
      patch({
        open: true,
        title,
        content,
        closeResult: null,
      })
    );
  }

  @Action(CloseDialog)
  closeDialog(context: StateContext<ConfirmationDialogStateModel>) {
    context.setState(
      patch({
        open: false,
        title: '',
        content: '',
        closeResult: null,
      })
    );
  }

  @Action(SetCloseResult)
  setCloseResult(context: StateContext<ConfirmationDialogStateModel>, { closeResult }: SetCloseResult) {
    context.setState(patch({ closeResult }));
  }
}
